import { createContainer } from "unstated-next";
const PostPageContext = createContainer((initialState = {
    authorized: false,
    disabled: false
})=>{
    return initialState;
});
export const usePostPage = PostPageContext.useContainer;
export const PostPageProvider = PostPageContext.Provider;
